import apiClient from './client';
import { API_ENDPOINTS } from './config';

// Response types
export interface OtpSendResponse {
	success: boolean;
	message: string;
}

export interface OtpVerifyRequest {
	otpCode: string;
}

export interface OtpVerifyResponse {
	success: boolean;
	message: string;
}

export interface OtpResendResponse {
	success: boolean;
	message: string;
}

// OTP API functions
export const otpApi = {
	/**
	 * Send OTP to the user's phone number
	 * Uses the phone number associated with the authenticated user
	 */
	send: async (): Promise<OtpSendResponse> => {
		return apiClient.post<OtpSendResponse>(API_ENDPOINTS.OTP.SEND, {});
	},

	/**
	 * Verify the OTP code entered by the user
	 */
	verify: async (otpCode: string): Promise<OtpVerifyResponse> => {
		return apiClient.post<OtpVerifyResponse>(API_ENDPOINTS.OTP.VERIFY, { otpCode });
	},

	/**
	 * Resend OTP to the user's phone number
	 */
	resend: async (): Promise<OtpResendResponse> => {
		return apiClient.post<OtpResendResponse>(API_ENDPOINTS.OTP.RESEND, {});
	},
};

export default otpApi;
